import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
    Elements,
    StripeProvider
} from 'react-stripe-elements';
import CardForm from './Payment/CardForm'
import PaymentGuide from './Payment/PaymentGuide'

const { REACT_APP_STRIPE_API } = process.env

class Payment extends Component {
    state = {
    }
    componentWillUnmount() {
        this.props.dispatch({ type: 'togglePaymentField', isPaymentActive: false,})
    }
    render() {
        const { isPaymentActive, isPaymentGuideActive } = this.props.payment
        return (
            <React.Fragment>
                <Mask 
                    onClick={()=> this.props.dispatch({ type: 'togglePaymentField', isPaymentActive: false, isPaymentGuideActive: false})} 
                    isActive={isPaymentActive || isPaymentGuideActive}
                />
                <PaymentGuide isActive={isPaymentGuideActive}/>
                <StripeProvider apiKey={REACT_APP_STRIPE_API}>
                    <React.Fragment>
                        <Wrap isActive={isPaymentActive}>
                            <Elements>
                                <CardForm/>
                            </Elements>
                        </Wrap>
                    </React.Fragment>
            </StripeProvider>
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment
    }
}
export default connect(mapStateToProps)(Payment);
const Mask = styled.div`
    position: fixed;
    visibility: ${props => props.isActive ? 'visible' : 'hidden'};
    justify-content: center;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10001;
    background-color: rgba(0,0,0,.6);
    cursor: pointer;
    /* transition: all .2s ease-in-out; */
    /* filter blur 效果設在 Background component中 */
`
const Wrap = styled.div`
    position: fixed;
    visibility: ${props => props.isActive ? 'visible' : 'hidden'};
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10002;
    font-size: 16px;
    font-weight: 300;
    color: #787878;
    @media (max-width: 900px){
        min-width: 320px;
    }
    h1 {
      color: #32325d;
      font-weight: 400;
      line-height: 50px;
      font-size: 40px;
      margin: 20px 0;
      padding: 0;
    }
    label {
      color: #6b7c93;
      font-weight: 300;
      letter-spacing: 0.025em;
    }
    input,
    .StripeElement {
      display: block;
      /* margin: 10px 0 20px 0; */
      max-width: 500px;
      padding: 10px 14px;
      font-size: 1em;
      font-family: 'Source Code Pro', monospace;
      box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
      border: 0;
      outline: 0;
      border-radius: 4px;
      background: white;
    }
    input::placeholder {
      color: #aab7c4;
    }
    input:focus,
    .StripeElement--focus {
      box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;
      -webkit-transition: all 150ms ease;
      transition: all 150ms ease;
    }
`


// WEBPACK FOOTER //
// ./src/Payment.js